import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, input, OnInit, Output } from '@angular/core';
import { ComboBoxModule } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { CanvasControlComponent } from 'src/app/features/bizzmine/form/components/controls/canvas-control/canvas-control.component';
import { ChecklistsQuestion } from 'src/app/features/bizzmine/form/components/controls/execute-checklist-control/interfaces/checklists-question.interface';
import { ChecklistAnswerClassType } from 'src/models/ts/checklist-answer-class-type';
import { ResultClassValue } from 'src/models/ts/result-class-value';
import { SinglechoiceControlComponent } from '../../controls/singlechoice-control/singlechoice-control.component';
import { EditorComponent } from 'src/app/shared/components/editor/editor.component';
import { ColorService } from 'src/app/core/services/colors/color.service';
import { getDisplayStyleForNumber } from 'src/app/shared/functions/helpers/display-style-helpers';

@Component({
  selector: 'bizz-checklist-answer-types',
  standalone: true,
  imports: [
    CommonModule,
    SinglechoiceControlComponent,
    CanvasControlComponent,
    TextBoxModule,
    NumericTextBoxModule,
    ComboBoxModule,
    EditorComponent
  ],
  templateUrl: './answers.component.html',
  styleUrl: './answers.component.scss'
})
export class ChecklistAnswerTypesComponent implements OnInit {
  @Input() public isMobileView: boolean = false;
  @Input({ required: true }) public question: ChecklistsQuestion;
  public isLocked = input.required<boolean>();
  @Output() public questionChange = new EventEmitter<ChecklistsQuestion>;
  @Output() public resetButtonsOptions = new EventEmitter<boolean>();
  @Input() public isDarkTheme: boolean = false;
  @Input() public reportControl: boolean = false;
  public backgroundColor: string;
  public foregroundColor: string;
  public hasDisplayStyle: boolean = false;
  public inputHasFocus: boolean;
  public ChecklistAnswerClassType = ChecklistAnswerClassType;

  //public canvasConfigOptions = ;

  public constructor(public colorService: ColorService) {
  }

  public ngOnInit(): void {
    switch (this.question.ResultClass.ResultClassType) {
      case ChecklistAnswerClassType.Numeric:
        if (!isNaN(Number(this.question.UserAnswer.Value))) {
          this.updateBackgroundColor(this.question.UserAnswer.Value as number);
        }
        break;
    }
  }

  public dispatchChange(question: ChecklistsQuestion): void {
    if (!this.isLocked()) {
      this.questionChange.emit(question);
    }
  }

  public setValue(value: string): void {
    if (this.answerIsNull()) {
      this.question.UserAnswer.Value = value;
    } else {
      this.resetButtonsOptions.emit(true);
      this.question.UserAnswer.Value = value;
      this.question.UserAnswer.Answer = null;
      this.question.UserAnswer.ResultClassValueID = undefined;
    }
    this.questionChange.emit(this.question);
  }

  public setNumericText(number: number): void {
    const displayValue = getDisplayStyleForNumber(this.question.ResultClass.ResultClassValues.Values as any, number) as unknown as ResultClassValue;

    if (!displayValue) return console.warn('No matching range found for value: ', number);
    this.question.UserAnswer.Value = number;
    this.question.UserAnswer.Answer = displayValue;
    this.question.UserAnswer.ResultClassValueID = displayValue.ID;
    this.questionChange.emit(this.question);
  }

  public updateBackgroundColor(number: number): void {
    const displayValue = getDisplayStyleForNumber(this.question.ResultClass.ResultClassValues.Values as any, number) as unknown as ResultClassValue;
    if (displayValue && displayValue.BackgroundColor) {
      this.backgroundColor = displayValue.BackgroundColor;
      this.foregroundColor = displayValue.ForegroundColor ?? '';
      this.hasDisplayStyle = true;
    } else {
      this.hasDisplayStyle = false;

    }
  }

  private answerIsNull(): boolean {
    return this.question.UserAnswer.Value === null && this.question.UserAnswer.Answer === null;
  }

  public onFocus(): void {
    if (!this.isLocked()) {
      this.inputHasFocus = true;
    }
  }

  public onBlur(): void {
    this.inputHasFocus = false;
  }
}
